import React, { Component } from 'react';
import PT from 'prop-types';

export class Label extends Component {
    render() {
        let labelInner = null;
        if(this.props.bold)
            labelInner = <strong>{this.props.children}</strong>;
        else
            labelInner = this.props.children;

        return (
            <label>{labelInner}</label>
        );
    }
}
Label.propTypes = {
    bold: PT.bool
};
Label.defaultProps = {
    bold: true
};
